import { render, staticRenderFns } from "./SeparationDivorceProceedingStartedYN.vue?vue&type=template&id=49f19870"
import script from "./SeparationDivorceProceedingStartedYN.vue?vue&type=script&lang=js"
export * from "./SeparationDivorceProceedingStartedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports